export default "__VITE_ASSET__CDw7bZXE__"